import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import AdminRallyPageLayout from '../../../layout/AdminRallyPageLayout';
const EditRallyPage = () => {
    const { t } = useTranslation();
    const { id } = useParams();
    return (_jsx(AdminRallyPageLayout, { title: `${t('admin.edit_rally')}.`, rallyId: id, formType: 'edit' }));
};
export default EditRallyPage;
